// extracted by mini-css-extract-plugin
export default {"decorator":"_1Uyh8fyILxZzo71IJ343tR","icon":"QVxTcYmxWmI1deQDScxA1"};